import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col } from 'react-bootstrap';
import { ButtonGroupToggle, ToggleSwitch } from '../../widgets';
import { isToday } from '../../../helpers/common';
import { updateConfiguration, userConfiguration } from '../../../actions/user';
import { setLoadQueueType } from '../../../actions/load';

const LoadQueueHeader = props => {
	const {
		onRefresh,
		onHide,
		isEdited, selectedLoadIds, isPlanterAllocation
	} = props;

	const loadQueueType = useSelector(state => state.load.loadQueueType);
	const { range } = useSelector(state => state.analyze.searchParams);
	const autoRefresh = useSelector(state => state.user.configuration.autoRefresh && state.user.configuration.autoRefresh.hasOwnProperty("load_queue")
		? state.user.configuration.autoRefresh.load_queue : true);

	const dispatch = useDispatch();

	const handleRefreshToggle = (e) => {
		const isChecked = e.target.checked;
		const cb = (isSaved) => !isSaved && props.actions.userConfiguration("autoRefresh", { load_queue: !isChecked });
		dispatch(userConfiguration("autoRefresh", { load_queue: isChecked }));
		dispatch(updateConfiguration({
			configuration_name: "AutoRefresh",
			configuration: { load_queue: isChecked }
		}, cb));
		if (isChecked) onRefresh();
	}
	const handleToggle = (value, e) => {
		dispatch(setLoadQueueType(value, e));
	}

	return <div className="row">
		<div className='load-queue-header w-100 ml-3'>
			{/* <div>
            <SearchInput
                initialValue={searchText}
                onChange={onSearch}
                placeholder="Search for Crew, EG" />
        </div> */}
			<Col lg={6} md={6} sm={6} xs={6} className='mb-4'>
				<div className="load-queue-btn-grp">
					<ButtonGroupToggle
						value={loadQueueType}
						onSelect={handleToggle}
						options={[
							{ value: 1, label: "Queue" },
							{ value: 2, label: isPlanterAllocation ? "Completed" : "History" }
						]} />
				</div>
			</Col>
			<Col lg={6} md={6} sm={6} xs={6}>
				<div className="d-flex align-items-center float-right">
					{/* <i
                    title="Load History"
                    className="fa fa-history btn-load-history"
                    aria-hidden="true"
                    onClick={props.onLoadHistory}
                />
                <div className="splitter" /> */}
					<div className="d-flex options ">
						{loadQueueType === 1 && isToday(range) && <>
							<span className="toggle-switch-label">Auto refresh</span>
							<ToggleSwitch
								className={(autoRefresh && (isEdited || selectedLoadIds.length > 0)) ? "toggle-switch-fade" : "toggle-switch"}
								title={autoRefresh ? "Disable auto refresh" : "Enable auto refresh"}
								onChange={(e) => handleRefreshToggle(e)}
								checked={autoRefresh}
							/>
						</>}
						<div style={{ width: "70px", height: "20px" }} className="d-flex">
							{(!autoRefresh || !isToday(range) || loadQueueType === 2) && <><i
								title="Refresh"
								className="fa fa-refresh btn-refresh"
								aria-hidden="true"
								onClick={onRefresh}
							/> <span className="splitter" /></>}
						</div>
					</div>
					<span className="d-inline-block">
						<i
							title="Close"
							className="fa fa-times btn-close"
							aria-hidden="true"
							onClick={onHide}
						/>
					</span>
				</div>
			</Col>
		</div>
	</div>
}

export default LoadQueueHeader;